import { List } from 'foundations-components/transitional/components/List';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import _get from 'hs-lodash/get';
import { buildName } from '../../utils/contacts';
import SuggestionsListRow from './SuggestionsListRow';
import { jsx as _jsx } from "react/jsx-runtime";
function SuggestionsList({
  contacts,
  selectContact,
  contactToAssociateId
}) {
  const onSelectContact = contact => {
    selectContact(contact);
  };
  return /*#__PURE__*/_jsx(List, {
    wrapChildren: true,
    children: contacts.map(contact => {
      const contactId = _get(contact, 'id');
      const email = _get(contact, 'email');
      const name = buildName(contact);
      return /*#__PURE__*/_jsx(SelectableBox, {
        type: "default",
        flush: true,
        selected: contactId === contactToAssociateId,
        onClick: () => onSelectContact({
          id: contactId,
          email,
          firstName: contact.firstname,
          lastName: contact.lastname
        }),
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(SuggestionsListRow, {
          email: email,
          name: name,
          checked: contactId === contactToAssociateId,
          contactId: contactId
        })
      }, contactId);
    })
  });
}
export default SuggestionsList;